<template>
    <div>
        <edit-production-staff-modal
            v-model="show_staff_dialog"
            :input="production"
            :memberId="production.id"
            :modelProp="staffSelected"
            :valuelists="valuelists"
            :members="membersList"
            @successful-staff-save="refreshStaffData"
        />
        <div class="tw-p-1" v-show="isUserAdminOrStaff">
            <v-btn class="main-btn" @click="addStaff()">Add Staff</v-btn>
        </div>
        <smart-table
            id="production_staff_list"
            endpoint="productionstaff.list"
            :headers="headers"
            :items-per-page="20"
            :footer-props="{
                'items-per-page-options': [5, 10, 20, 30]
            }"
            flat
            :display_fields="displayed_column_names"
            class="row-pointer"
            ref="production_staff_list"
            @click:row="editStaff"
        >
            <template v-slot:item.sort_order="{ isMobile, item, header, value, index}">
                <div class="tw-text-base">{{ item.sort_order}}</div>
            </template>
            <template v-slot:item.staff_role.name="{ isMobile, item, header, value, index}">
                <div class="tw-text-base">{{ item.staff_role.name}}</div>
            </template>
            <template v-slot:item.name="{ isMobile, item, header, value, index}">
                <div class="tw-text-base">{{ item.name }}</div>
            </template>
        </smart-table>
    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import InternalHeader from "@/Generic/InternalHeader";
    import EditProductionStaffModal from "@/Pages/InternalPages/Productions/Modals/EditProductionStaffModal";

    export default {
        name: "MembersManageStaff",
        components: {
            SmartTable,
            InternalHeader,
            EditProductionStaffModal,
        },
        props: {
            'input': {
                type: Object,
                required: true,
                default: function () {
                    return {}
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'isEditProp': {
                type: Boolean,
                required:false,
                default: function() {
                    return false
                }
            },
        },
        data() {
            return {
                show_staff_dialog: false,
                staffSelected: null,
                production: this.input,
                constant: this.constants,
                valuelist: this.valuelists,
                filters: {
                    production_id: this.input.id,
                },
                errors: null,
                membersList: null,
            }
        },
        computed: {
            headers() {
                return [
                    {value: 'sort_order',      text: 'Sort Order',         align: `start`, sortable: true, optional: false, },
                    {value: 'staff_role.name', text: 'Staff Position',     align: `start`, sortable: false, optional: false, },
                    {value: 'name',            text: 'Name',               align: `start`, sortable: true, optional: false, },
                    {value: 'production_id',   text: 'production_id',      align: `start`, sortable: false,   filterable: true,   search: this?.filters?.production_id, optional: false, },
                ]
            },
            displayed_column_names() {
                let headers_to_display = this.headers.filter(header => this.should_column_be_displayed(header.value))
                return headers_to_display.map(header => header.value)
            },
            isUserAdminOrStaff() {
                return this.$page.user.role === 'ADMIN' || this.$page.user.role === 'STAFF';
            },
        },
        mounted() {
            this.getDeferredValuelists()
        },
        methods: {
            getDeferredValuelists() {
                axios.post(route('members.member-producer-valuelist'))
                    .then((response)=>{
                        this.membersList = response?.data?.map((member) => member.text)
                    })
            },
            should_column_be_displayed(column) {
                let required_headers = ['sort_order', 'staff_role.name', 'name']
                return required_headers.includes(column)
            },
            editStaff(item) {
                this.staffSelected = item
                this.show_staff_dialog = true
            },
            addStaff() {
                this.staffSelected = null
                this.show_staff_dialog = true
            },
            refreshStaffData() {
                this.$refs.production_staff_list.refreshList()
            },
        },
        watch: {
            input(newInput, oldInput) {
                this.production = newInput
            },
        }
    }
</script>
<style>

.row-pointer tbody tr {
    cursor: pointer;
}

</style>
